export const chatReducer = (state = {}, action) => {
  switch (action.type) {
    case "GET_CHAT_LIST_REQUEST": {
      return {
        ...state,
        loading: true,
        chats: null,
      };
    }
    case "GET_CHAT_LIST_SUCCESS": {
      return {
        ...state,
        loading: false,
        chats: action.payload,
      };
    }
    case "GET_CHAT_LIST_FAILED": {
      return {
        ...state,
        loading: false,
        chats: action.payload,
      };
    }

    case "GET_CHAT_REQUEST": {
      return {
        ...state,
        loading: true,
        individualChat: null,
      };
    }
    case "GET_CHAT_SUCCESS": {
      return {
        ...state,
        loading: false,
        individualChat: action.payload,
      };
    }
    case "GET_CHAT_FAILED": {
      return {
        ...state,
        loading: false,
        individualChat: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};
